// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__1uNIb","left":"StickyBox_left__3qkpW","right":"StickyBox_right__phhg2"};